import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { DaoGeneric } from '../../base/daoService';
import { environment } from '@Env/environment';
import {RoleEntite} from '@Services/gestion-universite/roles/role-entite';

@Injectable({
  providedIn: 'root'
})
export class ManageRoleService extends DaoGeneric<RoleEntite> {
  private urlBase = `${environment.baseUrl}`;
  private urlApi = `${this.urlBase}/gestion_universite/manageroles/`;

  constructor(public httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(urlApp?: string): string {
    console.log('getRootUrl ManageRoleService');

    if (urlApp) {
      return `${this.urlBase}${urlApp}`;
    }

    return this.urlApi;
  }

  deleteRole(role_entite, urlApp = '/gestion_universite/manageroles/') {
    const url = `${this.getRootUrl(urlApp)}?role_entite=${role_entite}`;
    return this.httpClient.delete(url);
  }
  deleteRoleBulk(roles_entite: number[], urlApp = '/gestion_universite/manageroles/') {
    const url = `${this.getRootUrl(urlApp)}?roles_entite=${roles_entite.join(',')}`;
    return this.httpClient.delete(url);
  }

  createRoleBase(role, uid, entite, urlApp = '/gestion_universite/manageroles/') {
    const url = `${this.getRootUrl(urlApp)}`;
    const data = {individu: uid, role: role, entite: entite};

    return this.httpClient.post(url, JSON.stringify(data));
  }
}
